export default __webpack_public_path__ + "static/media/goodjobsound2trimmed.2b9eb72c.wav";